import React from 'react';
import { Box, Typography, useTheme, Stepper, Step, StepLabel, StepButton } from '@mui/material';
import { ProcessStep, StageDetails } from '../../types/processFlowTypes';

interface StageStepperProps {
  stageDetails: Record<string, StageDetails>;
  currentStage: string;
  onStageClick: (node: ProcessStep) => void;
}

const StageStepper: React.FC<StageStepperProps> = ({
  stageDetails,
  currentStage,
  onStageClick
}) => {
  const theme = useTheme();
  const stageEntries = Object.entries(stageDetails);
  const activeStep = stageEntries.findIndex(([id]) => id === currentStage);

  return (
    <Box 
      sx={{ 
        mb: 3,
        px: 4,
        width: '68vw' 
      }}
    >
      <Stepper activeStep={activeStep} alternativeLabel nonLinear>
        {stageEntries.map(([stageId, stage]) => {
          const firstNodeId = stage.steps[0]?.id;
          return (
            <Step key={stageId} completed={false}>
              <StepButton 
                onClick={() => {
                  if (firstNodeId) {
                    onStageClick(stage.steps[0]);
                  }
                }}
                sx={{
                  '& .MuiStepLabel-iconContainer': {
                    '& .MuiStepIcon-root': {
                      color: currentStage === stageId ? theme.palette.primary.main : theme.palette.grey[400],
                      '&.Mui-active': {
                        color: theme.palette.primary.main,
                      },
                    },
                  }
                }}
              >
                <StepLabel
                  sx={{
                    '& .MuiStepLabel-label': {
                      color: currentStage === stageId ? theme.palette.primary.main : theme.palette.text.secondary,
                      fontWeight: currentStage === stageId ? 'bold' : 'normal',
                    }
                  }}
                >
                  {stage.title}
                </StepLabel>
              </StepButton>
            </Step>
          )
        })}
      </Stepper>
    </Box>
  );
};

export default StageStepper;
